<div>
    <button class="fas fa-chevron-double-left leftArrow" (click)="jumpToPg(1)" [disabled]="page === 1" tooltip="Primeira página"></button>
    <button class="fas fa-chevron-left leftArrow" (click)="previousPg()" [disabled]="page === 1" tooltip="Página Anterior"></button>
    <span>Página</span>
    <input min="1" [max]="getAllPages()" type="number" [value]="page" (change)="evtJumpToPg($event)">
    <span>de {{ getAllPages() }}</span>
    <button class="fas fa-chevron-right rightArrow" (click)="nextPg()" [disabled]="page === getAllPages()" tooltip="Próxima Página"></button>
    <button class="fas fa-chevron-double-right rightArrow" (click)="jumpToPg(getAllPages())" [disabled]="page === getAllPages()" tooltip="Última Página"></button>
    <span class="page-text-info">Registros {{ getFirst() }} à {{ getLast() }}. Total: {{ collectionSize }}</span>

</div>
